import { render } from "./YantaiAI.vue?vue&type=template&id=7d67da4f&scoped=true"
import script from "./YantaiAI.vue?vue&type=script&lang=js"
export * from "./YantaiAI.vue?vue&type=script&lang=js"

import "./YantaiAI.vue?vue&type=style&index=0&id=7d67da4f&scoped=true&lang=scss"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d67da4f"]])

export default __exports__